import React, { useEffect, useState } from "react";
import { homeUrl } from "../../constant";
import { makeStyles } from "@mui/styles";
import { useNavigate, useLocation, createSearchParams, json } from "react-router-dom";
import Loader from "../../components/Loader";
import NavBar from "../NavBar/NavBar";
import Form from "../../components/Form";

const useStyles = makeStyles(() => ({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
}));

const Phonepe = () => {
  const initialState = {
    clientCode: "",
    mobile: "",
    client_email: "",
    product_plan_id: "",
    gst: "",
    first_name: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    return_url: `${homeUrl}/payment/${paymentMethod}/phonepe`,
  };



  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const search = useLocation().search;
  const [reqParams, setReqParams] = useState(initialState);
  var paymentMethod = new URLSearchParams(search).get("paymentMethod");
  // const [isInvalidMobile, setInvalidMobile] = useState(false);

  let clientCode = "";
  let mobile = "";
  let client_email = "";
  let product_plan_id = "";
  let gst = "";
  let first_name = "";
  let address = "";
  let city = "";
  let pincode = "";
  let return_url = initialState.return_url;

  clientCode = new URLSearchParams(search).get("clientCode");
  mobile = new URLSearchParams(search).get("mobile");
  client_email = new URLSearchParams(search).get("mailId");
  product_plan_id = new URLSearchParams(search).get("planCode");
  first_name = new URLSearchParams(search).get("first_name");
  address = new URLSearchParams(search).get("address");
  city = new URLSearchParams(search).get("city");
  pincode = new URLSearchParams(search).get("pincode");

  if (clientCode === "%22null%22" || clientCode === "null") {
    clientCode = mobile;
  }



  useEffect(() => {
    setReqParams({
      ...reqParams,
      clientCode: clientCode,
      mobile: mobile,
      client_email: client_email,
      gst: gst,
      product_plan_id: product_plan_id,
      first_name: first_name,
      address: address,
      city: city,
      pincode: pincode,
      state: "",
      return_url:initialState.return_url
    });
    redirectTonext();
  }, [
    reqParams.mobile,
    reqParams.product_plan_id,
    loader,
    reqParams.pincode,
    reqParams.address,
    reqParams.first_name,
  ]);

  // When all form data is available then its directily checkout Phonepe 
  const redirectTonext = async () => {
    const {
      clientCode,
      client_email,
      mobile,
      product_plan_id,
      gst,
      first_name,
    } = reqParams;

    if (clientCode && client_email &&
      mobile &&
      product_plan_id && first_name
    ) {
      setLoader(true);
      const req = {
        product_plan_id: (reqParams.product_plan_id) || "",
        client_email: reqParams.client_email || "",
        client_mobile: Number(reqParams.mobile) || "",
        client_code: reqParams.clientCode || "",
        gst: gst || "",
        first_name: reqParams.first_name || "",
        address: reqParams.address || "",
        city: reqParams.city || "",
        pincode: reqParams.pincode || "",
        state: reqParams.state || "" || "",
        return_url:return_url,
      };
      navigate({
        pathname: '/details',
        search: `?${createSearchParams({ ...req, paymentMethod: paymentMethod, paymentGateway: 'phonpe' })}`,
      });
    }
  };

  return (
    <div>
      {/* <NavBar /> */}
      {loader ? (
        <div className="loader">
          <Loader message="please wait.. " />
        </div>
      ) : (
        <div className="container">
          <Form data={reqParams} />
        </div>
      )}
    </div>
  );
};

export default Phonepe;
